// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brand-tagline-text[data-v-11ae8de8]{font-family:\"Neue Plak Bold\",sans-serif;font-size:.875rem;color:#fff;margin-bottom:1px!important;-webkit-backface-visibility:hidden;backface-visibility:hidden;transform:translateZ(0) scale(1)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
